import './i18n/setup';
import '@refinedev/antd/dist/reset.css';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { RefineContext } from './app/refine-context';
import { AppRoutes } from './app/routes';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <RefineContext>
      <AppRoutes />
    </RefineContext>
  </BrowserRouter>,
);
